import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {AJAX, getEmailForMessages, setCookie} from "../functions";

class MailboxIcon extends Component {
    state = {count: 0};

    home_url = window.bm_url;


    constructor(props) {
        super(props);
        window.getCountMessages = this.getCountMessages = this.getCountMessages.bind(this);
        this.clickByLink = this.clickByLink.bind(this);
        this.getIcon = this.getIcon.bind(this);
        this.isGreen = this.isGreen.bind(this);
        this.getCountMessages();
    }

    isGreen() {
        return this.state.count > 0 ? " green" : ""
    }

    getIcon() {
        return (
            <svg className={"mailbox-icon" + this.isGreen()}
                version="1.1" id="bm-mbx-icon" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 184 184">
                <g fill="white">
                    <path d="M160.746,24.61H23.254C10.432,24.61,0,35.042,0,47.864v88.271c0,12.822,10.432,23.254,23.254,23.254
		h137.492c12.822,0,23.254-10.432,23.254-23.254V47.864C184,35.042,173.568,24.61,160.746,24.61z M157.113,39.61L92,89.909
		L26.887,39.61H157.113z M160.746,144.39H23.254c-4.551,0-8.254-3.703-8.254-8.254V49.382l72.415,55.94
		c1.35,1.043,2.968,1.564,4.585,1.564s3.235-0.521,4.585-1.564L169,49.382v86.753C169,140.687,165.297,144.39,160.746,144.39z"/>
                </g>
            </svg>
        );
    }

    getCountMessages() {
        let t = this;
        let email = getEmailForMessages();
        setCookie('bm_email_messages', email, 3*365);
        if (!!email) {
            let params = {
                action: 'api/booking/get_count_new_messages',
                email: email
            };
            AJAX(bm_ajax_url, "POST", params, {
                response_json: true,
                func_callback: function (resp) {
                    if (resp.success === 1 && Object.keys(resp.data).length > 0) {
                        t.setState({count: resp.data.count})
                    }
                }
            })
        }
    }

    clickByLink() {
        if (this.props.currentPathName === '/messages/') {
            if (typeof window.updateMessagesPage === 'function') {
                window.updateMessagesPage();
            }
        }
    }

    render() {
        let link;
        if (this.props.notUseReact) {
            link = <a href={this.home_url + '/messages/'} className="">{this.getIcon()}</a>
        } else {
            link = <Link to='/messages/' onClick={this.clickByLink} className="" >{this.getIcon()}</Link>
        }
        return (
            <>
                {link}
                {
                    this.state.count > 0 ? (
                        <span className={"text-btn-navigation" + this.isGreen()}>New message{this.state.count > 1 ? 's' : ''}</span>
                    ) : ('')
                }

            </>
        );
    }
}

export default MailboxIcon;